/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 697
// module chunks = 0